<template>
    <div ref="spContainer" class="sp-container" @mouseenter="showSituationCard()" @mouseleave="showSituationCard()">
        <div @click="spClick()">
          <div class="sp-dot"  :class="{ 'sp-currentSituation': spisCurrentSitation()}"/>
          <div class="sp-ppl" v-if="this.myUsersLength && enableCommunication">{{this.myUsersLength}}</div>
        </div>
        <div ref="spCard" class="sp-situationcard" @click="spClick()">
            <SituationCard v-show="showCard" :situationID="this.situationID"/>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import SituationCard from '@/components/flux360/SituationCard'

export default {
    components: {SituationCard},
    props: ['situationID'],
    inject: ['toggleMap'],
	data: () => ({
        showCard: false,
        cardOpened: false,
    }),
	methods: {
        isTouchDevice() {  
          return 'ontouchstart' in window;
        },
		showSituationCard(){
            this.showCard=!this.showCard;
            this.cardOpened=false;
        },
        gotoSituation(){
            this.toggleMap();
            this.$store.commit('handleGotoSituationTransition', { situationID: this.situationID } );     
        },
        spClick() {
            if(this.isTouchDevice()){
                if(this.cardOpened){
                    this.gotoSituation();
                }
                this.cardOpened = true;
            }else
                this.gotoSituation();   
        },
        spisCurrentSitation(){
            return this.currentSituationID == this.situationID;
        }
    },
    computed: {
        ...mapGetters(['situations','currentSituationID',"users","enableCommunication"]),
        myUsersLength(){
            let users = this.users.filter( x => x.getCurrentSituationID() == this.situationID);
            if(users && users.length > 0)             
                return users.length;          
            return false;
        },
    },
    mounted: function(){
        let style = getComputedStyle(this.$refs.spContainer);
        let left = parseInt(style.left);
        let top = parseInt(style.top);
        let card = this.$refs.spCard;
        if(top>60)
            card.style.top = -250+"px";
        if(left>60)
            card.style.left = -380+"px";
    }
}
</script>

<style>
.sp-container:hover .sp-dot {
    transform: scale(2);
    z-index: 5;
}
.sp-container:hover .sp-ppl{
    transform: scale(1.5);
    z-index: 6;
    cursor: pointer;
}
.sp-dot{
    z-index: 1;
    position: relative;
    cursor: pointer;
    height: 30px;
    width:  30px;
    border-radius: 50%;
    background: var(--secondaryColor);
    display: inline-block;
    filter: drop-shadow(0px 0px 2px  var(--secondaryColor)) drop-shadow(0px 0px 2px  var(--secondaryColor));
    transition: background-color .2s, transform .2s, filter .2s;
}
.sp-ppl{
    z-index: 3;
    position: absolute;
    font-size: 18px;
    left: 50%;
    top: 70%;
    height: 30px;
    width: 30px;
    background-color: rgb(39, 39, 39);
    border-radius: 50%;  
    text-align: center;
    line-height: 28px;
    color: rgb(231, 231, 231);
    transition: transform .2s;
}
.sp-situationcard{
    z-index: 4;
    position: absolute;
    top: 60%;
    left: 60%;
}
.sp-currentSituation{
    transform: scale(1.5);
    z-index: 2;
    background: var(--primaryColor);
    filter: drop-shadow(0px 0px 2px  var(--primaryColor)) drop-shadow(0px 0px 2px  var(--primaryColor));
    
}
/*DESKTOP SMALL*/
@media (max-width: 1200px) { 
   .sp-dot{
        height: 25px;
        width:  25px;
    }
    .sp-ppl{
        font-size: 14px;
        height: 15px;
        width: 15px;
        line-height: 15px;
    }
}
</style>